import { useQuery } from "@tanstack/react-query";
import { useAuth, useUser } from "reactfire";
import toast from "react-hot-toast";
import getUserCredit from "../handler/getUserCredit";

export const USER_CREDIT_QUERY_KEY = "user-earning";

/**
 * Hook to fetch user credit data (points, claimable points, level, rewards)
 * @returns TanStack Query result with user credit data
 */
export function useUserCreditQuery() {
  const auth = useAuth();
  const { data: userData } = useUser();
  const USER_ID = userData?.uid;

  return useQuery({
    queryKey: [USER_CREDIT_QUERY_KEY],
    queryFn: async () => {
      const token = await auth.currentUser?.getIdToken();

      if (!token) {
        toast.error("Something went wrong. Please try again.");
        console.log("token missing");
        return;
      }

      return getUserCredit(USER_ID, token);
    },
    enabled: !!USER_ID,
  });
}
